<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：项目展示 > 基本信息
    </div>
    <div class="content-info">
      <h3 class="form-title flex-center">
        项目展示
      </h3>
      <div class="step-box">
        <div class="step-title">
          <div class="step-title-text">
            1.基本信息
          </div>
        </div>
        <div class="padding">
          <el-form ref="importInfo" :model="importInfo" :rules="rules" label-width="200px">

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="机构名称：" class="margin-bottom-sm">
                  <el-input v-model="name" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="机构类型：" class="margin-bottom-sm">
                  <div class="input-container active">
                    <el-radio-group v-model="importInfo.org_type" :max="1" disabled>
                      <el-radio label="社会团体" name="type"></el-radio>
                      <el-radio label="社会服务机构" name="type"></el-radio>
                      <el-radio label="基金会" name="type"></el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="注册地址：" class="margin-bottom-sm">
                  <el-input v-model="address" disabled></el-input>
                </el-form-item>
              </el-col>
              <!--              <el-col :span="6">-->
              <!--                <el-form-item label="登记证号：" class="margin-bottom-sm" label-width="90px">-->
              <!--                  <el-input v-model="regist_no" disabled></el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <el-col :span="12">
                <el-form-item label="登记时间：" class="margin-bottom-sm">
                  <el-input v-model="chengli_time" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系人：" class="margin-bottom-sm">
                  <el-input v-model="contacts" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话：" class="margin-bottom-sm">
                  <el-input v-model="phone" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="电子邮箱：" class="margin-bottom-sm">
                  <el-input v-model="email" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="机构网站：" class="margin-bottom-sm">
                  <el-input v-model="website" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="登记管理机关：" class="margin-bottom-sm">
                  <el-input v-model="administration" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="业务主管/指导单位：" class="margin-bottom-sm">
                  <el-input v-model="business_unit" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="社会组织评估等级：" class="margin-bottom-sm">
                  <el-input v-model="importInfo.level" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="等级评估有效期截止时间：" class="margin-bottom-sm">
                  <el-input v-model="importInfo.end_time" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="法人代表：" class="margin-bottom-sm">
                  <el-input v-model="legal_person" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话：" class="margin-bottom-sm" prop="shenbao_phone">
                  <el-input v-model="importInfo.shenbao_phone" placeholder="请输入法人联系电话" :disabled="isSubmit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="2019年资产总额：" class="margin-bottom-sm" prop="assets">
                  <el-input v-model="importInfo.assets" placeholder="请输入2019年资产总额" :disabled="isSubmit"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="2019年总支出：" class="margin-bottom-sm" prop="expenditure">
                  <el-input v-model="importInfo.expenditure" placeholder="请输入2019年总支出" :disabled="isSubmit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="机构领域（可多选）：" class="margin-bottom-sm" prop="range">
              <div class="input-container active">
                <el-checkbox-group v-model="importInfo.range" :disabled="isSubmit">
                  <el-checkbox label="扶贫" name="area"></el-checkbox>
                  <el-checkbox label="济困" name="area"></el-checkbox>
                  <el-checkbox label="扶老" name="area"></el-checkbox>
                  <el-checkbox label="救孤" name="area"></el-checkbox>
                  <el-checkbox label="恤病" name="area"></el-checkbox>
                  <el-checkbox label="助残" name="area"></el-checkbox>
                  <el-checkbox label="救灾" name="area"></el-checkbox>
                  <el-checkbox label="助医" name="area"></el-checkbox>
                  <el-checkbox label="助学" name="area"></el-checkbox>
                  <el-checkbox label="环境保护" name="area"></el-checkbox>
                  <el-checkbox label="社区治理与营造" name="area"></el-checkbox>
                  <el-checkbox label="会员服务" name="area"></el-checkbox>
                  <!--                  <el-checkbox label="疫情防控、复工复产" name="area"></el-checkbox>-->
                  <el-checkbox label="行业协调" name="area"></el-checkbox>
                  <el-checkbox label="行业自律" name="area"></el-checkbox>

                  <el-checkbox label="行业服务" name="area"></el-checkbox>
                  <el-checkbox label="其他" name="area">其他
                    <el-input v-model="areaother" v-if="importInfo.range.indexOf('其他')!==-1" class="input-type"
                              size="mini" placeholder="请填写"></el-input>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item label="信用状况（2017-2019）：" class="margin-bottom-xs" prop="sx">
              <div class="xy-box">
                <div class="xy-item active">
                  <div>机构或机构负责人存在失信行为</div>
                  <el-radio-group v-model="importInfo.is_dishonesty" :disabled="isSubmit">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </div>
                <div class="xy-item active">
                  <div>机构受到登记管理机关或其他部门行政处罚或行政处罚尚未执行完毕</div>
                  <el-radio-group v-model="importInfo.is_punish" :disabled="isSubmit">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </div>
                <div class="xy-item">
                  <div>机构或机构负责人正在被司法机关或有关部门立案调查</div>
                  <el-radio-group v-model="importInfo.is_investigation" :disabled="isSubmit">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div class="file-tip">附件：请附电子版法人登记证书，如已参加等级评估，请附等级评估证书。</div>
          <div class="file-box">
            <div class="file-container">
              <div class="file-title"><span>* </span>电子法人登记证书：</div>
              <upFile :img-title="'legal_person_img'" :accept="'image/*'" @setImg="setImg" v-if="!isSubmit"></upFile>
              <div class="file-img-container iconfont" v-if="legal_person_img">
                <i class="el-icon-error" @click="delImg(0)" v-if="!isSubmit"></i>
                <el-image
                  style="width: 183px; height: 130px"
                  :src="legal_person_img"
                  fit="scale-down"
                  :preview-src-list="[legal_person_img]">
                </el-image>
              </div>
            </div>
            <div class="file-container">
              <div class="file-title"> 等级评估证书：</div>
              <upFile :img-title="'level_img'" :accept="'image/*'" @setImg="setImg" v-if="!isSubmit"></upFile>
              <div class="file-img-container iconfont" v-if="level_img">
                <i class="el-icon-error" @click="delImg(1)" v-if="!isSubmit"></i>

                <el-image
                  style="width: 183px; height: 130px"
                  :src="level_img"
                  fit="scale-down"
                  :preview-src-list="[level_img]">
                </el-image>
              </div>
            </div>
          </div>

        </div>
        <div class="step-title flex-center">
          <div class="step-title-text">
            2.荣誉表彰
          </div>
        </div>
        <div class="padding">
          <el-row :gutter="30">
            <el-col :span="24" v-for="(item,index) in ryArr" :key="index">
              <div class="demeanour-item ">
                <el-row :gutter="30">
                  <el-col :span="16">
                    <div class="flex-start"><span>获奖时间:</span>
                      <p>{{ item.winning_time }}</p></div>
                    <div class="flex-start"><span>荣誉名称:</span>
                      <p>{{ item.honor_name }}</p></div>
                    <div class="flex-start"><span>颁发单位:</span>
                      <p>{{ item.issued_unit }}</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div><span>证明资料：</span><img :src="item.prove_material" alt=""></div>
                    <div class="demeanour-item-btn">
                      <el-button type="warning" @click="editItem(index)" v-if="!isSubmit">编辑</el-button>
                      <el-button type="danger" @click="closeItem(index)" v-if="!isSubmit">删除</el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-button type="warning" class="add-item-btn" @click="hadleOpen('')" v-if="ryArr.length<10 && !isSubmit">
            添加荣誉表彰
          </el-button>
        </div>
        <div class="operate" v-if="!isSubmit">
          <el-button class="operate-submit" @click="saveForm()" v-if="base_state === 0">保存</el-button>
          <el-button class="operate-next" @click="submitFrom('importInfo')">提交</el-button>
        </div>
      </div>
    </div>

    <el-dialog
      title="荣誉表彰编辑"
      :visible.sync="dialogVisible"
      width="800px"
      center
      :before-close="handleClose">
      <div class="dislog-from">
        <el-form :model="formRy" :rules="rulesFc" ref="formRy" label-width="150px" class="demo-ruleForm">
          <el-form-item label="获得时间" prop="time">
            <el-date-picker
              style="width: 100%;"
              v-model="formRy.time"
              type="month"
              placeholder="请选择获得时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="荣誉名称" prop="name">
            <el-input v-model="formRy.name" placeholder="请输入荣誉名称"></el-input>
          </el-form-item>
          <el-form-item label="颁发单位" prop="org">
            <el-input v-model="formRy.org" placeholder="请输入颁发单位"></el-input>
          </el-form-item>
          <el-form-item label="证明资料" prop="img">
            <div class="up-file-box">
              <upFile :img-title="'ry'" :accept="'image/*'" @setImg="setImg"></upFile>
              <div class="up-img" v-if="formRy.img">
                <img class="logo" :src="formRy.img" alt="">
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="editFc('formRy')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import upFile from "../../components/upFile";
// import upFile2 from "../../components/upFile2";

export default {
  name: "addOrg",
  components: {
    upFile,
    // upFile2
  },
  data() {
    var validateAreaOther = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请选择服务领域'));
      } else {
        if (value.indexOf('其他') !== -1 && !this.areaother) {
          callback(new Error('请输入其他'));
        } else {
          callback();
        }
      }
    };
    var validateSx = (rule, value, callback) => {
      if (this.importInfo.is_dishonesty === '' || this.importInfo.is_dishonesty === undefined) {
        callback(new Error('机构或机构负责人存在失信行为'));
      } else if (this.importInfo.is_punish === '' || this.importInfo.is_punish === undefined) {
        callback(new Error('机构受到登记管理机关或其他部门行政处罚或行政处罚尚未执行完毕'));
      } else if (this.importInfo.is_investigation === '' || this.importInfo.is_investigation === undefined) {
        callback(new Error('机构或机构负责人正在被司法机关或有关部门立案调查'));
      } else {
        callback();
      }
    };
    return {
      id: 0,
      base_state: 0,
      isSubmit: false,
      importInfo: {
        org_type: '',
        range: [],
        shenbao_phone: '',
        assets: '',
        expenditure: '',
        level: '',
        end_time: '',
        is_dishonesty: '',
        is_punish: '',
        is_investigation: '',
      },
      name: '',
      address: '',
      regist_no: '',
      chengli_time: '',
      legal_person: '',
      contacts: '',
      phone: '',
      email: '',
      website: '',
      administration: '',
      business_unit: '',
      areaother: '',
      legal_person_img: '',
      level_img: '',
      state: 0,
      rules: {
        // org_type: [
        //   {required: true, message: '请选择机构类型', trigger: 'change'},
        // ],
        range: [
          {type: 'array', required: true, message: '请选择服务领域', trigger: 'change'},
          {type: 'array', validator: validateAreaOther, trigger: 'change'}
        ],
        shenbao_phone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'}
        ],
        assets: [
          {required: true, message: '请填写2019年资产总额', trigger: 'blur'}
        ],
        expenditure: [
          {required: true, message: '请填写2019年总支出', trigger: 'blur'}
        ],
        sx: [
          {required: true, validator: validateSx, trigger: 'change'}
        ],
      },
      dialogVisible: false,
      ryArr: [],     //  荣誉
      setId: '',     //  荣誉修改id
      formRy: {
        time: '',
        name: '',
        org: '',
        img: '',
      },
      rysubmitState: true,
      rulesFc: {
        time: [
          {required: true, message: '请选择获奖时间', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入荣誉名称', trigger: 'blur'},
        ],
        org: [
          {required: true, message: '请输入颁发单位', trigger: 'blur'},
        ],
        img: [
          {required: true, message: '请上传照片', trigger: 'change'},
        ]
      }
    }
  },
  created() {
    this.getSubmit()
    this.$emit('setIndex', 2)
    this.init()
    this.getHonorList()
  },
  methods: {
    getSubmit() {
      this.$api.apiContent.isSubmit({
        token: this.$store.state.user.token,
      }).then(res => {
        this.isSubmit = !res.data.flag
      }).catch(e => {
        console.log(e)
      })
    },
    /*
    * 编辑风采
    * */
    editItem(index) {
      this.formRy = {
        time: new Date(this.ryArr[index].winning_time),
        name: this.ryArr[index].honor_name,
        org: this.ryArr[index].issued_unit,
        img: this.ryArr[index].prove_material,
      }
      this.hadleOpen(this.ryArr[index].id)
    },
    /*
    * 删除风采
    * */
    closeItem(index) {
      this.$confirm('您确定要删除当前荣誉表彰吗?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        type: 'warning'
      }).then(() => {
        this.$api.apiContent.honorDel({
          token: this.$store.state.user.token,
          honor_id: this.ryArr[index].id
        }).then(() => {
          this.$message.success('删除成功')
          this.getHonorList()
        }).catch(e => {
          this.$message.error(e.msg)
        })
      }).catch(() => {

      });
    },
    /*
    * 添加/修改风采
    * */
    editFc(formName) {
      if (!this.rysubmitState) return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.rysubmitState = false
          if (this.setId) {
            this.$api.apiContent.addHonor({
              token: this.$store.state.user.token,
              winning_time: this.$tools.ZHDate(this.formRy.time, 3),
              honor_name: this.formRy.name,
              issued_unit: this.formRy.org,
              prove_material: this.formRy.img,
              honor_id: this.setId,

            }).then(() => {
              this.rysubmitState = true
              this.$message.success('修改成功')
              this.getHonorList()
              this.handleClose()
            }).catch(e => {
              this.rysubmitState = true
              this.$message.error(e.msg)
            })
          } else {
            this.$api.apiContent.addHonor({
              token: this.$store.state.user.token,
              winning_time: this.$tools.ZHDate(this.formRy.time, 3),
              honor_name: this.formRy.name,
              issued_unit: this.formRy.org,
              prove_material: this.formRy.img,
            }).then(() => {
              this.rysubmitState = true
              this.$message.success('添加成功')
              this.getHonorList()
              this.handleClose()
            }).catch(e => {
              this.rysubmitState = true
              this.$message.error(e.msg)
            })
          }
        }
      });


    },
    /*
    * 打开弹框
    * */
    hadleOpen(id) {
      this.setId = id
      this.dialogVisible = true
      if (!this.setId) {
        this.$refs['formRy'].clearValidate();
      }
    },
    /*
    * 关闭弹框
    * */
    handleClose() {
      this.setId = ''
      this.formRy = {
        time: '',
        name: '',
        org: '',
        img: '',
      }
      this.dialogVisible = false
    },

    /*
    * 获取荣誉列表
    * */
    getHonorList() {
      this.$api.apiContent.getHonorList({
        token: this.$store.state.user.token
      }).then(res => {
        console.log(res)
        this.ryArr = res.data ? res.data : []
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },


    //  保存
    saveForm() {
      let range = ''
      if (this.importInfo.range.indexOf('其他') !== -1) {
        range = this.importInfo.range.join(',') + ',' + this.areaother
      } else {
        range = this.importInfo.range.join(',')
      }
      this.$api.apiContent.setBaseinfoSave({
        token: this.$store.state.user.token,
        baseinfo_id: this.id,
        range: range,
        assets: this.importInfo.assets,
        shenbao_phone: this.importInfo.shenbao_phone,
        expenditure: this.importInfo.expenditure,
        is_dishonesty: this.importInfo.is_dishonesty,
        is_punish: this.importInfo.is_punish,
        is_investigation: this.importInfo.is_investigation,
        level_img: this.level_img,
        legal_person_img: this.legal_person_img
      }).then(res => {
        this.$message.success(res.msg)
        this.init()
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    //  提交判断
    submitFrom(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.legal_person_img) {
            this.submitFormTwo()
          } else {
            this.$message.error('请先上传电子法人登记证书')
          }
        } else {
          this.$message.error('信息未填写完整，请确认')
          return false;
        }
      });
    },
    //  数据提交
    submitFormTwo() {
      let range = ''
      if (this.importInfo.range.indexOf('其他') !== -1) {
        range = this.importInfo.range.join(',') + ',' + this.areaother
      } else {
        range = this.importInfo.range.join(',')
      }
      this.$api.apiContent.setBaseinfoSave({
        token: this.$store.state.user.token,
        baseinfo_id: this.id,
        base_state: 1,
        range: range,
        assets: this.importInfo.assets,
        shenbao_phone: this.importInfo.shenbao_phone,
        expenditure: this.importInfo.expenditure,
        is_dishonesty: this.importInfo.is_dishonesty,
        is_punish: this.importInfo.is_punish,
        is_investigation: this.importInfo.is_investigation,
        level_img: this.level_img,
        legal_person_img: this.legal_person_img
      }).then(res => {
        this.$message.success(res.msg)
        this.$router.push('/home/addProject')
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },


    init() {
      this.$api.apiContent.getBaseinfoSave({
        token: this.$store.state.user.token,
      }).then(res => {
        this.id = res.data.id ? res.data.id : ''

        this.base_state = res.data.base_state
        this.name = res.data.name
        this.address = res.data.address
        this.regist_no = res.data.regist_no
        this.chengli_time = res.data.chengli_time
        this.legal_person = res.data.legal_person
        this.contacts = res.data.contacts
        this.phone = res.data.phone
        this.email = res.data.email
        this.website = res.data.website
        this.administration = res.data.administration
        this.business_unit = res.data.business_unit
        this.state = res.data.status
        this.importInfo.org_type = res.data.org_type
        this.importInfo.level = res.data.level
        this.importInfo.end_time = res.data.end_time
        if (res.data.range) {
          let range = res.data.range.split(',')
          if (range.indexOf('其他') !== -1) {
            this.importInfo.range = range.splice(0, range.length - 1)
            this.areaother = range[range.length - 1]
          } else {
            this.importInfo.range = range
          }
        }
        this.importInfo.org_type = res.data.org_type === '民办非企业单位' ? '社会服务机构' : res.data.org_type
        this.importInfo.assets = res.data.assets
        this.importInfo.shenbao_phone = res.data.shenbao_phone
        this.importInfo.expenditure = res.data.expenditure
        this.importInfo.is_dishonesty = res.data.is_dishonesty !== '' ? res.data.is_dishonesty : ''
        this.importInfo.is_punish = res.data.is_punish !== '' ? res.data.is_punish : ''
        this.importInfo.is_investigation = res.data.is_investigation !== '' ? res.data.is_investigation : ''
        this.level_img = res.data.level_img
        this.legal_person_img = res.data.legal_person_img
      }).catch(() => {
      })
    },
    delImg(type) {
      let that = this
      that.$confirm('你确定要删除该图片吗?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (type === 0) {
          that.legal_person_img = ''
        } else {
          that.level_img = ''
        }
      }).catch();

    },
    setImg(obj) {
      console.log(obj)
      switch (obj.title) {
        case 'legal_person_img':
          this.legal_person_img = obj.url
          return
        case 'level_img':
          this.level_img = obj.url
          return
        case 'ry':
          this.formRy.img = obj.url
          return
      }
    }
  }
}
</script>

<style scoped lang="scss">
.content-info {
  .form-title {
    height: 56px;
    padding: 0 30px;
    border-bottom: 2px solid #f2f2f2;
    position: relative;
    font-size: 18px;

    &:before {
      position: absolute;
      top: 17px;
      left: 15px;
      content: '';
      width: 6px;
      height: 22px;
      background-color: #f9aa0d;
    }

    span {
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #999999;
    }

    p {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;

      b {
        color: #c70005;
      }
    }
  }

  .form-step {
    padding: 20px 40px;

    span {
      width: 180px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #999999;
      background-color: #e8e8e8;
      border-radius: 21px;

      &.active {
        background-color: #f9aa0d;
        color: #fff;
      }
    }
  }

  .step-box {
    margin-top: 30px;
    padding-bottom: 20px;

    .xy-box {
      display: flex;
      flex-direction: column;
      border-radius: 4px;
      border: solid 1px #DCDFE6;

      .xy-item {
        padding: 8px 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        &.active {
          border-bottom: solid 1px #DCDFE6;
        }
      }
    }

    .operate {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 50px;

      .operate-submit {
        width: 150px;
        height: 60px;
        background-color: #0087d4;
        border-radius: 30px;
        font-size: 16px;
        line-height: 30px;
        color: #ffffff;
      }

      .operate-next {
        width: 314px;
        height: 60px;
        margin-left: 50px;
        background-image: linear-gradient(90deg,
          #f9aa0d 0%,
          #e44730 100%),
        linear-gradient(
            #f9aa0d,
            #f9aa0d);
        background-blend-mode: normal,
        normal;
        border-radius: 30px;
        font-size: 16px;
        line-height: 30px;
        color: #ffffff;
      }
    }

    .file-box {
      display: flex;
      flex-direction: row;

      .file-container {
        display: flex;
        flex-direction: row;
        height: 185px;
        border: 1px solid #eeeeee;
        align-items: center;
        flex: 1;

        .file-title {
          width: 200px;
          font-size: 16px;
          text-align: right;

          span {
            color: red;
          }
        }

        .file-up {
          flex-shrink: 0;
          width: 131px;
          height: 131px;
          margin-left: 14px;
        }

        .file-img-container {
          margin-left: 14px;
          position: relative;

          i {
            font-size: 26px;
            color: #f9aa0d;
            position: absolute;
            top: -15px;
            right: -15px;
            cursor: pointer;
            z-index: 99;
          }

          .file-img {
            width: 183px;
            height: 130px;
          }
        }

      }
    }

    .file-tip {
      width: 100%;
      height: 50px;
      font-size: 16px;
      line-height: 50px;
      padding-left: 36px;
      background-color: #ffe6e7;
      margin-top: 20px;
    }

    .input-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      min-height: 42px;

      &.active {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        padding: 0 12px;
      }

      .input-type {
        width: 120px;
        height: 27px;
      }

      span {
        margin-right: 20px;
        flex-shrink: 0;
      }
    }

    .step-title {
      .step-title-text {
        width: 179px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        font-size: 18px;
        font-weight: normal;
        font-style: italic;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        background: url(../../assets/img/title.png) no-repeat center;
      }

      .step-title-tips {
        flex: 1;
        padding: 10px;
        line-height: 16px;
        font-size: 12px;
        background-color: #fff4f4;
        border-radius: 4px;
        border: solid 1px #ffe8e8;
        color: #c70005;

        span {
          color: #999;
        }
      }
    }

    .up-file-box {
      display: flex;
      align-items: center;

      .up-img {
        display: flex;
        align-items: center;
        width: 130px;
        height: 130px;
        position: relative;
        margin: 0 30px;
        overflow: hidden;

        //&:after {
        //  position: absolute;
        //  top: 0;
        //  right: 0;
        //  content: 'X';
        //  width: 20px;
        //  height: 20px;
        //  font-size: 12px;
        //  text-align: center;
        //  line-height: 20px;
        //  border-radius: 20px;
        //  color: #fff;
        //  background: #c70005;
        //  cursor: pointer;
        //}

        img {
          display: block;
          width: 130px;

          &.logo {
            height: 130px;
            border-radius: 130px;
          }
        }
      }

    }

    .demeanour-item {
      margin-bottom: 30px;
      padding: 20px 20px 10px;
      border: 1px solid #c70005;
      border-radius: 5px;

      div {
        //display: flex;
        //align-items: self-start;
        margin-bottom: 5px;

        span {
          display: block;
          width: 80px;
          line-height: 24px;

          b {
            padding: 0 14px;
          }
        }

        p {
          flex: 1;
          line-height: 24px;
        }

        img {
          flex: 1;
          display: block;
          width: auto;
          max-width: 100%;
          height: 200px;
          margin: 0 auto;
        }
      }

      .demeanour-item-btn {
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
    }

  }

  .add-item-btn {
    display: block;
    width: 150px;
    margin: 0 auto;
  }
}

.dislog-from {
  .up-file-box {
    display: flex;
    align-items: center;

    .up-img {
      margin: 0 30px;

      img {
        display: block;
        height: 130px;
      }
    }

  }
}
</style>
